import { Directive } from '@angular/core';
import { AbstractControlOptions, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

@Directive()
export abstract class PrDefiscFormBuilder extends PrFormAbstract {
  generate(entity: any) {
    let options: AbstractControlOptions = {};

    return this.formBuilder.group(
      {
        id: [entity ? entity.id : null],
        type: [
          entity ? entity.type : null,
          [
            this.prFormService.RefreshEveryValidators([
              'girardinRate',
              'taxReductionRate',
            ]),
            Validators.required,
          ],
        ],
        label: [entity ? entity.label : null, Validators.required],
        purchasePrice: [
          entity ? entity.purchasePrice : null,
          Validators.required,
        ],
        girardinRate: [
          entity.girardinRate
            ? Math.round(entity.girardinRate * 100 * 100) / 100
            : null,
          [
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo('type', val => val == 'GIRARDIN')
                .bind(this),
              Validators.required,
            ),
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo('type', val => val != 'GIRARDIN')
                .bind(this),
              Validators.max(100),
            ),
          ],
        ],
        taxReductionRate: [
          entity.taxReductionRate
            ? entity.type === 'SOFICA'
              ? entity.taxReductionRate
              : Math.round(entity.taxReductionRate * 100 * 100) / 100
            : null,
          [
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo('type', val =>
                  ['SOFICA', 'FIP', 'FCPI', 'FIP_CORSE', 'FIP_DOMTOM'].includes(
                    val,
                  ),
                )
                .bind(this),
              Validators.required,
            ),
          ],
        ],
        startDate: [entity ? entity.startDate : null, Validators.required],
        endDate: [entity ? entity.endDate : null],
        contratId: [entity ? entity.contratId : null, Validators.required],
        source: [
          entity ? entity.subscriptionSource : null,
          Validators.required,
        ],
        subscriptionId: [entity ? entity.subscriptionId : null],
        accountId: [entity ? entity.accountId : null, Validators.required],
        userId: [entity ? entity.userId : null, Validators.required],
        owners: [this.buildInitialOwners(entity), Validators.required],
      },
      options,
    );
  }

  extract() {
    let dto: any = {
      id: this.emptyIsNull(this.form.value.id),
      type: this.emptyIsNull(this.form.value.type),
      label: this.emptyIsNull(this.form.value.label),
      purchasePrice: this.emptyIsNull(this.form.value.purchasePrice),
      girardinRate: this.emptyIsNull(this.form.value.girardinRate / 100),
      taxReductionRate: this.emptyIsNull(
        this.form.value.type === 'SOFICA'
          ? this.form.value.taxReductionRate
          : this.form.value.taxReductionRate / 100,
      ),
      startDate:
        new Date(this.form.value.startDate).toISOString().split('.')[0] + 'Z',
      endDate: this.form.value.endDate
        ? new Date(this.form.value.endDate).toISOString().split('.')[0] + 'Z'
        : null,
      contratId: this.emptyIsNull(
        this.form.value.contratId.name
          ? this.form.value.contratId.name
          : this.form.value.contratId,
      ),
      subscriptionSource: this.emptyIsNull(this.form.value.source),
      subscriptionId: this.emptyIsNull(this.form.value.subscriptionId),
      accountId: this.emptyIsNull(this.form.value.accountId),
      userId: this.emptyIsNull(this.form.value.userId),
      owners: this.form.value.owners,
    };
    return dto;
  }
}
